import React from 'react'

function Body() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <g>
                <path
                    fill="currentColor"
                    d="M19.758 6.492L16.5 3.333a4.541 4.541 0 00-3.167-1.25c-.091 0-.358-.058-.416.25A3.075 3.075 0 0110 5a3.075 3.075 0 01-2.908-2.667c-.059-.308-.334-.225-.417-.25A4.542 4.542 0 003.5 3.333L.242 6.492a.833.833 0 000 1.183l1.941 1.933a.833.833 0 001.15.059l1.034-.833a.408.408 0 01.441-.042.417.417 0 01.192.375v7.917a.833.833 0 00.833.833h8.334a.834.834 0 00.833-.834V9.168a.418.418 0 01.233-.375.408.408 0 01.442.042l1.025.791a.834.834 0 001.117-.05l1.941-1.933a.833.833 0 000-1.15z"
                ></path>
            </g>
        </svg>
    )
}

export default Body
